import React from 'react';
import { MuiTitle } from 'src/ui/mui-ui-kit';;
import propTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { AsideCard } from './AsideCard';

const requirements = [
  {
    text: 'Must be at least 8 characters in length',
    check: 'hasEightCharacters',
  },
  {
    text:
      'Must contain at least one uppercase, lowercase, numeric and special characters',
    check: 'hasSpecialCharacters',
  },
];

export const PasswordRequirements = props => (
  <AsideCard className="password-requirements">
    <MuiTitle tag="h3" hasTextColor="purple-light" className="is-size-7">
      Password Requirements
    </MuiTitle>
    <ul className="requirements-list">
      {requirements.map(({ text, check }) => {
        const requirementClassName = classNames('requirement', {
          'has-text-info': !!props[check],
          'has-text-grey-medium-dark': !props[check],
        });

        return (
          <li className={requirementClassName} key={check}>
            <span className="icon is-medium">
              <FontAwesomeIcon icon={['fal', 'check-circle']} size="lg" />
            </span>
            <span className="text">{text}</span>
          </li>
        );
      })}
    </ul>
  </AsideCard>
);

export const GenericPasswordRequirements = props => (
  <ul className="requirements-list">
    {requirements.map(({ text, check }) => {
      const requirementClassName = classNames('requirement', {
        'has-text-green': !!props[check],
        'has-text-grey-medium-dark': !props[check],
      });

      return (
        <li className={requirementClassName} key={check}>
          <span className="icon is-medium">
            <FontAwesomeIcon icon={['fal', 'check-circle']} size="sm" />
          </span>
          <span className="text">{text}</span>
        </li>
      );
    })}
  </ul>
);
PasswordRequirements.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  hasEightCharacters: propTypes.bool.isRequired,
  hasSpecialCharacters: propTypes.bool.isRequired,
  /* eslint-enable */
};

GenericPasswordRequirements.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  hasEightCharacters: propTypes.bool.isRequired,
  hasSpecialCharacters: propTypes.bool.isRequired,
  /* eslint-enable */
};
